<template>
  <div class="rounded-lg bg-theme-2 p-6">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>
